import { Component } from '@angular/core';
import { LoginService } from '../../services/login/login.service';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styleUrls: ['./usuario.component.css']
})
export class UsuarioComponent {

  constructor(private loginService: LoginService) { }

  clickGuard() {
    this.loginService.dataUser = '';
    this.loginService.clickGuard = true;
  }

}
